import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { X, Key } from "lucide-react";

export default function SetPasswordModal({ open, user, onClose, onSaved }) {
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    if (!open) return;
    setPassword("");
    setErr("");
  }, [open]);

  if (!open || !user) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { setErr("Password must be at least 6 characters"); return; }
    setSaving(true);
    try {
      await api.post(`/users/${user.id}/set-password`, { password });
      toast.success(`Password set for ${user.name}`);
      onSaved();
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid="set-password-modal">
      <div className="w-full max-w-sm iz-card p-8 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 p-1.5 rounded hover:bg-[#1c1c1c] text-gray-500"><X className="w-4 h-4"/></button>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 flex items-center justify-center">
            <Key className="w-4 h-4 text-[#d4af37]" strokeWidth={1.5}/>
          </div>
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#d4af37]">Set login password</p>
            <h3 className="font-display text-xl text-white">{user.name}</h3>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-gray-400 mb-2">New Password</label>
            <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} className="iz-input" placeholder="min. 6 chars" data-testid="set-password-input" required/>
            <p className="text-[10px] text-gray-500 mt-2 font-mono">Share the credentials with the user securely.</p>
          </div>
          {err && <div className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 rounded-md px-3 py-2">{err}</div>}
          <div className="flex justify-end gap-3 pt-4 border-t border-[#1a1a1a]">
            <button type="button" onClick={onClose} className="iz-btn-secondary">Cancel</button>
            <button type="submit" disabled={saving} className="iz-btn-primary" data-testid="set-password-submit">{saving ? "Saving…" : "Set password"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
